import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { AssessmentPage } from './pages/AssessmentPage';
import { ReportPage } from './pages/ReportPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/avaliacao" element={<AssessmentPage data-id="element-5" />} data-id="element-4" />
        <Route path="/relatorio" element={<ReportPage data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}